import {
  CreateProviderAnnotationsRequest,
  GarnerProviderAnnotationsClientV1,
} from '@garner-health/api-client/svc-providers/provider-annotations/provider-annotations-v1';

import createLogger from '~/logging';

import { baseClientOptions, getDefaultHeaders } from './common';

const log = createLogger(__filename);

export type Annotation = CreateProviderAnnotationsRequest['json']['annotations'][0];

export type AnnotationField =
  | 'phoneNumber'
  | 'street1'
  | 'city'
  | 'state'
  | 'zipCode'
  | 'faxNumber'
  | 'acceptsNewPatients'
  | 'knownDisciplinaryAction'
  | 'activelyTreatingPatients'
  | 'specialty';

export type ProviderDetailParams = {
  specialty: string;
  locationId: string;
  networkId: string;
};

type CreateAnnotationParams = {
  providerId: string;
  searchParams: ProviderDetailParams;
  annotations: Annotation[];
};

export class ProviderAnnotationsClient {
  readonly client: GarnerProviderAnnotationsClientV1;

  constructor(options = baseClientOptions) {
    this.client = new GarnerProviderAnnotationsClientV1(options);
  }

  async createAnnotation({ providerId, searchParams, annotations }: CreateAnnotationParams): Promise<void> {
    const { locationId, networkId, specialty } = searchParams;
    if (!annotations.length) return;

    await this.client
      .post('/provider-annotations/{provider_id}', {
        headers: await getDefaultHeaders(),
        params: { provider_id: providerId },
        json: {
          locationId,
          networkId,
          specialty,
          annotations,
        },
      })
      .onStatus(200, () => void 0)
      .onStatus(422, r => {
        log.error(
          {
            message: r.json.message,
            requestId: r.json.requestId,
            context: { ...r.json, annotations },
          },
          'Invalid annotation',
        );
      })
      .catch(err => {
        log.error(
          { err, locationId, networkId, strSpecialty: specialty, context: annotations },
          'Error submitting annotation',
        );
      });
  }
}

export const providerAnnotationsClient = new ProviderAnnotationsClient();
